import { Card, CardContent, CardHeader, CardTitle } from '@/client/components/ui/card';
import { Badge } from '@/client/components/ui/badge';
import { Users, User, Mail } from 'lucide-react';
import type { ClientTech } from '@shared/types';

interface TechsCardProps {
  techs: ClientTech[];
}

export function TechsCard({ techs }: TechsCardProps) {
  if (techs.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base font-medium flex items-center gap-2">
            <Users className="h-4 w-4" />
            Techs
          </CardTitle>
          <Badge variant="secondary">{techs.length}</Badge>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {techs.map((tech) => (
            <div key={tech.techID} className="space-y-2">
              <div className="flex items-center gap-2">
                <User className="h-4 w-4 text-muted-foreground" />
                <span className="font-medium text-sm">{tech.techName}</span>
              </div>

              {tech.assignedUsers.length > 0 && (
                <div className="ml-6 space-y-1">
                  {tech.assignedUsers.map((user) => (
                    <div
                      key={user.userId}
                      className="flex items-center gap-2 text-sm text-muted-foreground"
                    >
                      <Mail className="h-3 w-3" />
                      <span>
                        {user.firstName || user.lastName
                          ? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim()
                          : user.email}
                      </span>
                      {(user.firstName || user.lastName) && (
                        <span className="text-xs">({user.email})</span>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {tech.assignedUsers.length === 0 && (
                <p className="ml-6 text-sm text-muted-foreground italic">
                  No users assigned
                </p>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
